import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as actions from './actions'

Vue.use(Vuex)

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/)

const modules = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
  )
  .reduce((modules, [name, module]) => {
    modules[name] = module
    return modules
  }, {})

export default new Vuex.Store({
  plugins: [createPersistedState({
    getState: function (key, storage) {
      let result
      try {
        let value = storage.getItem(key)

        result = value && typeof value !== 'undefined'
          ? JSON.parse(value)
          : undefined
      } catch (err) {
        result = undefined
      }

      // Reset the selected table number after one day
      if (result !== null && typeof result === 'object') {
        if (
          result.hasOwnProperty('config') &&
          result.config !== null &&
          typeof result.config === 'object' &&
          result.config.hasOwnProperty('tbdata') &&
          typeof result.config.tbdata === 'object'
        ) {
          // The 21600 is six hours
          if (result.config.visitAtTimestamp && result.config.visitAtTimestamp < (Math.ceil((new Date()).getTime() / 1000) - 21600)) {
            result.config.tb = ''
            result.config.tbdata = null

            console.log('Reset the selected table')
          } else {
            console.log('Waiting time is not up, no need to reset yet, Skip...')
          }
        }
      }

      return result
    }
  })],
  actions,
  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js